import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { APP_FLOW_DTL, APP_FLOW_STEPS } from '../../../../constants/apiRoutes';
import { LISTING_LIMIT } from '../../../../constants/applicationConstants';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';

/**
 * list Steps.
 * @returns {Promise} - A promise that resolves with the list of Tests or rejects with an error.
 * @param props
 */
export const listSteps = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${APP_FLOW_STEPS}/filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    steps: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * list Application Flow Steps By AF ID
 * @returns {Promise} - A promise that resolves with the list of Test Arguments or rejects with an error.
 * @param props
 */
export const listAppFlowStepByID = async ({
  limit,
  offset,
  filter,
  sort = [],
  uc_ossi_af_id,
  isStepRequired = true,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : (offset ?? 1),
    pageSize: limit ?? LISTING_LIMIT,
    sort,
  };
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW_DTL.replace('{afId}', doubleEncode(uc_ossi_af_id))}/Filter/${isStepRequired}`,
    method: 'POST',
    body: data,
    accessToken,
  });
  return {
    steps: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Application Flow Step.
 * @returns {Promise} - A promise that resolves with the creation of Application Flow or rejects with an error.
 * @param data
 */
export const createFlowStep = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW_DTL.replace('{afId}', doubleEncode(data.UcOssiAfId))}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Application Flow.
 * @returns {Promise} - A promise that resolves with the update of Application Flow or rejects with an error.
 * @param data
 */
export const updateFlowStep = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW_DTL.replace('{afId}', doubleEncode(data.UcOssiAfId))}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Delete Application Flow Step.
 * @returns {Promise} - A promise that resolves with the update of Application Flow or rejects with an error.
 * @param data
 */
export const deleteFlowStep = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW_DTL.replace('{afId}', doubleEncode(data.UcOssiAfId))}?prodId=${encodeURIComponent(data?.UcOssiProdId)}&afId=${encodeURIComponent(data?.UcOssiAfId)}&afDtlSeq=${encodeURIComponent(data?.UcOssiAfDtlSeq)}&afStpId=${encodeURIComponent(data?.UcOssiAfStepId)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
